import axios from 'axios';
import { DELETE_CLIENT } from '../../constants';

export const deleteClient = (cID, closeDialog, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadDeleteClient());
  axios
    .put(`/client/deleteClient/?clientId=${cID}`, {}, config)
    .then((res) => {
      dispatch(setDeleteClient(res));
      closeDialog();
    })
    .catch((err) => {
      dispatch(errorDeleteClient(err.response));
      onError(err.response);
    });
};

export const loadDeleteClient = () => ({
  type: DELETE_CLIENT.LOAD,
});

export const setDeleteClient = (data) => ({
  type: DELETE_CLIENT.SUCCESS,
  payload: data,
});

export const errorDeleteClient = (error) => ({
  type: DELETE_CLIENT.FAIL,
  payload: error,
});
